var React = require('react');

function Default (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z","stroke":"#555555"}));
}

Default.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Default;

Default.default = Default;
